module.exports = __webpack_public_path__ + "media/images/trash_can_off-bcbf8059b5de45cb4399f36ba53ce1be.png";